import SvgIcon from "@mui/material/SvgIcon";

export default function AnimalPerformanceIcon() {
  return (
    <SvgIcon
      viewBox="0 0 24 25"
      sx={{ width: "24", height: "25", transform: "scale(1.8)" }}
    >
      <path
        d="M7.5 14.288H6C5.58579 14.288 5.25 14.6238 5.25 15.038V19.913C5.25 20.3272 5.58579 20.663 6 20.663H7.5C7.91421 20.663 8.25 20.3272 8.25 19.913V15.038C8.25 14.6238 7.91421 14.288 7.5 14.288Z"
        fill="#F6C34A"
      />
      <path
        d="M12 12.038H10.5C10.0858 12.038 9.75 12.3738 9.75 12.788V19.913C9.75 20.3272 10.0858 20.663 10.5 20.663H12C12.4142 20.663 12.75 20.3272 12.75 19.913V12.788C12.75 12.3738 12.4142 12.038 12 12.038Z"
        fill="#F6C34A"
      />
      <path
        d="M16.5 8.66296H15C14.5858 8.66296 14.25 8.99875 14.25 9.41296V19.913C14.25 20.3272 14.5858 20.663 15 20.663H16.5C16.9142 20.663 17.25 20.3272 17.25 19.913V9.41296C17.25 8.99875 16.9142 8.66296 16.5 8.66296Z"
        fill="#F6C34A"
      />
      <path
        d="M5.625 10.913C9 7.91296 12.375 6.78796 15.75 9.03796L16.875 6.78796L19.125 12.413L13.125 11.288L14.4375 9.78796C12.1875 8.66296 9.9375 9.41296 7.6875 11.663L5.625 10.913Z"
        fill="#A795E3"
      />
      <path
        d="M3.75 5.47546C4.06066 5.47546 4.3125 5.22362 4.3125 4.91296C4.3125 4.6023 4.06066 4.35046 3.75 4.35046C3.43934 4.35046 3.1875 4.6023 3.1875 4.91296C3.1875 5.22362 3.43934 5.47546 3.75 5.47546Z"
        fill="white"
      />
      <path
        d="M20.625 4.53796C20.8321 4.53796 21 4.37007 21 4.16296C21 3.95586 20.8321 3.78796 20.625 3.78796C20.4179 3.78796 20.25 3.95586 20.25 4.16296C20.25 4.37007 20.4179 4.53796 20.625 4.53796Z"
        fill="white"
      />
      <path
        d="M19.5 19.538C19.7071 19.538 19.875 19.3701 19.875 19.163C19.875 18.9559 19.7071 18.788 19.5 18.788C19.2929 18.788 19.125 18.9559 19.125 19.163C19.125 19.3701 19.2929 19.538 19.5 19.538Z"
        fill="white"
      />
    </SvgIcon>
  );
}
